<script lang="ts">
  import NavBar from "@/components/molecules/NavBar.svelte";
  import SideBar from "@/components/molecules/SideBar.svelte";
  import Swipe from "@/components/molecules/Swipe.svelte";
  import SwipeItem from "@/components/molecules/SwipeItem.svelte";
  import VideoItem from "@/components/molecules/VideoItem.svelte";
  import * as css from "@/utils/css";
  import { onDestroy, onMount } from "svelte";
  import Bottombar from "../molecules/Bottombar.svelte";
  import ImageUrls from "@/constants/ImageUrls";
  import type { VideoItemType } from "@/types";
  import { browser } from "$app/environment";

  export let onSwipe: (index: number) => void,
    list: VideoItemType[],
    currentIndex = 0,
    showNavbar = true,
    toggleLikeCount: () => void,
    toggleInstallBanner: () => void,
    showInstallBanner = true;

  const swipeConfig = {
    autoplay: false,
    delay: 2000,
    showIndicators: false,
    transitionDuration: 200,
  };

  let windowHeight = "100vh",
    isDragging = false,
    showSideBar = false,
    isActive = true;

  const handleSwipe = (eventData: CustomEvent<{ activeIndex: number }>) => {
    const { detail } = eventData;
    const { activeIndex } = detail;
    if (onSwipe) onSwipe(activeIndex);
  };

  const handleDrag = ({ detail }: CustomEvent<boolean>) => {
    isDragging = detail;
  };

  const onResize = () => {
    windowHeight = `${window.innerHeight}px`;
  };

  const setSideBar = (newVal: boolean) => {
    showSideBar = newVal;
  };

  const onVisibilityChange = () => {
    isActive = document.visibilityState !== "hidden";
  };

  onMount(async () => {
    if (typeof window !== "undefined") {
      onResize();
    }
    if (browser) {
      document.addEventListener("visibilitychange", onVisibilityChange);
    }
  });

  onDestroy(() => {
    if (browser) {
      document.removeEventListener("visibilitychange", onVisibilityChange);
    }
  });
</script>

<svelte:window on:resize={onResize} />
<div class="swipe-holder max-h-full" style="height:{windowHeight}">
  {#if showSideBar && showInstallBanner}
    <SideBar {setSideBar} />
  {/if}
  <Bottombar />

  {#if list.length > 0}
    <Swipe
      on:swipe={handleSwipe}
      on:drag={handleDrag}
      totalItems={list.length}
      {...swipeConfig}
      defaultIndex={currentIndex}
      is_vertical={true}
      {isDragging}
    >
      <svelte:fragment slot="head">
        {#if showNavbar && showInstallBanner}
          <NavBar {setSideBar} />
        {/if}
      </svelte:fragment>

      <svelte:fragment slot="body">
        {#each list as item, index (index)}
          <SwipeItem
            shouldLoadVideo={currentIndex >= index - 1 &&
              currentIndex <= index + 1}
          >
            <div
              slot="video"
              class="relative w-[inherit] h-[inherit]"
              data-testid="video"
            >
              <VideoItem
                {index}
                {showSideBar}
                isItemInView={index === currentIndex && isActive}
                {item}
                {isDragging}
                {toggleLikeCount}
                {toggleInstallBanner}
              />
            </div>
          </SwipeItem>
        {/each}
      </svelte:fragment>
    </Swipe>
  {:else}
    <div class={`${css.allCenteredChild} h-full`}>
      <img
        class="max-w-[96px] object-contain"
        src={ImageUrls.MOJ_ICON}
        alt="logo"
      />
    </div>
  {/if}
</div>
